import { createAudioManager } from '@/app/utils/createAudioManager'
import { create } from 'zustand'
import { sample } from '@/app/utils/functions'

export const effectList = {
    success: '/sounds/effect/success.mp3',
    fail: '/sounds/effect/fail.mp3',
    button: '/sounds/effect/button.mp3',
    return: '/sounds/effect/return.mp3',
    alert: '/sounds/effect/alert.mp3',
    camera: '/sounds/effect/camera.mp3',
    exchange: '/sounds/effect/exchange.mp3'
} as const

export const narrationList = {
    'success-1': '/sounds/narration/success-1.mp3',
    'success-2': '/sounds/narration/success-2.mp3',
    'fail-1': '/sounds/narration/fail-1.mp3',
    'fail-2': '/sounds/narration/fail-2.mp3',
    'greeting': '/sounds/narration/greeting.mp3',
} as const

const deerAudioList = [
    '/sounds/deer/effect-1.mp3',
    '/sounds/deer/effect-2.mp3',
    '/sounds/deer/effect-3.mp3',
    '/sounds/deer/effect-4.mp3',
    '/sounds/deer/effect-5.mp3',
    '/sounds/deer/effect-6.mp3',
]

const audio = createAudioManager()

// type AudioType = 'music' | 'sfx' | 'narration'
type AudioType = 'music' | 'sfx'
type AudioState = {
    muted: boolean
    volume: Record<AudioType, number>
    playMusic: (url: string) => void
    playDeer: () => void
    playSFX: (type: keyof typeof effectList) => void
    playNarration: (type: keyof typeof narrationList) => void
    setVolume: (type: AudioType, value: number) => void
}

const useAudio = create<AudioState>((set, get) => ({
    muted: false,
    volume: {
        music: 1.0, // 0.6 ???
        sfx: 1.0,
        // narration: 1.0,
    },
    // setMuted: (muted) => {
    //     set({ muted })
    //     if (muted) {
    //         audio.setVolume('music', 0)
    //         audio.setVolume('sfx', 0)
    //         audio.setVolume('narration', 0)
    //     } else {
    //         audio.setVolume('music', get().volume.music)
    //         audio.setVolume('sfx', get().volume.sfx)
    //         audio.setVolume('narration', get().volume.narration)
    //     }
    // },
    setVolume: (type, value) => {
        set((state) => ({
            volume: {
                ...state.volume,
                [type]: value,
            },
        }))
        audio.setVolume(type, value)
    },
    playMusic: async (url) => {
        await audio.load(url)
        // audio.resume()
        audio.play(url, 'music', true)
    },
    playDeer: async () => {
        const url = sample(deerAudioList)
        await audio.load(url)
        // audio.resume()
        audio.play(url, 'sfx')
    },
    playSFX: async (type) => {
        if (get().muted) return
        const url = effectList[type] as string
        await audio.load(url)
        // audio.resume()
        audio.play(url, 'sfx')
    },
    playNarration: async (type) => {
        if (get().muted) return
        const url = narrationList[type] as string
        await audio.load(url)
        // audio.resume()
        audio.play(url, 'narration')
    }
}))

export default useAudio